import { useSuspenseQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from '@/lib/queryKeys'
import panelService from '@/lib/services/panelService'
import { GetPanelInviteParams } from '@/types/requests/companies'

export function usePanelInviteQuery(params: GetPanelInviteParams) {
  return useSuspenseQuery({
    queryKey: QUERY_KEYS.panelInvite(params),
    queryFn: () => panelService.getPanelInvite(params),
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 20000,
  })
}
